// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2713":"css/admin-app.7032","6496":"css/app.7032"}[chunkId] + ".css";
};